module.exports = __webpack_public_path__ + "static/media/file-medical-alt.e2cfad7b.svg";